<div class="theme-cards-container">
  @for (card of themeCards; track trackByTheme($index, card)) {
    <rt-theme-card
      [theme]="card.theme"
      [title]="card.title"
      [subtitle]="card.subtitle"
      [isActive]="activeThemeName() === card.theme"
      [iconHelpTooltip]="card.iconHelpTooltip"
      [width]="cardWidth()"
      [height]="cardHeight()"
      [backgroundSize]="themeCardBackgroundSize()"
      [attr.data-cy]="'settings:profile:appearance:' + card.theme"
      (click)="themeChange.emit(card.theme)"
    />
  }
</div>
